import React, { useEffect, useMemo, useState } from 'react';
import { dealwithChartsData } from '../../../utils';
import moment from 'moment';
import EChartCommon, {
  getAxisPointer,
} from '@/pages/opinion/components/EChartCommon';
import { echartsContent } from '@/pages/opinion/utils';
import {
  formatChartParamsDate,
  listTimeTitleFunc,
} from '@/pages/opinion/components/ChartCommon/formatter';
import { reviewsFormat } from '@/pages/opinion/utils/value';
import { useIntl } from 'umi';
import { ServerTimeType } from '@/pages/opinion/components/FilterCommon/types';
import { formatTimeXAxisText } from '@/pages/opinion/utils/chart';

export default function TotalCharts({
  type,
  originalData,
  dateType,
}: {
  type: 'bar' | 'line';
  originalData: Array<any>;
  dateType: ServerTimeType;
}) {
  const [xAxisData, setXAxisData] = useState<Array<string>>([]);
  const [todaySeries, setTodaySeries] = useState<Array<string>>([]);
  const [otherDaySeries, setOtherDaySeries] = useState<Array<string>>([]);
  const { formatMessage } = useIntl();

  useEffect(() => {
    const { xAxis, toDaySeries, otherDaySeries } = dealwithChartsData(
      originalData,
      'today',
      'lastWeek',
      (item, _index) => {
        return item.date;
      },
    );
    setXAxisData(xAxis);
    setTodaySeries(toDaySeries);
    setOtherDaySeries(otherDaySeries);
  }, [originalData]);

  const options = useMemo(() => {
    const option = {
      tooltip: {
        formatter: (params: any) => {
          return formatChartParamsDate({
            params: params,
            title: listTimeTitleFunc(params[0]?.axisValue, dateType),
            rightTitle: formatMessage({ id: 'Heat' }),
            valueFormat: reviewsFormat,
            listTitleFunc: (item: any) =>
              formatMessage({ id: item.seriesName }),
          });
        },
      },
      color: ['#5086F3', '#77E097'],
      legend: {
        data: ['Today', 'Same Day Last Week'],
        icon: 'circle',
        formatter: function (name: string) {
          return formatMessage({ id: name });
        },
      },
      axisPointer: getAxisPointer((data) =>
        formatTimeXAxisText(data.value, dateType),
      ),
      xAxis: {
        type: 'category',
        data: xAxisData,
        axisLabel: {
          formatter: (value: string) => formatTimeXAxisText(value, dateType),
        },
      },
      yAxis: {
        type: 'value',
        axisLabel: {
          formatter: (value: any) => {
            return echartsContent(value);
          },
        },
      },
      series: [
        {
          name: 'Today',
          type: type,
          barGap: 0.1,
          data: todaySeries,
        },
        {
          name: 'Same Day Last Week',
          type: type,
          data: otherDaySeries,
        },
      ],
    };

    return option;
  }, [dateType, type, xAxisData, todaySeries, otherDaySeries, formatMessage]);

  return (
    <EChartCommon
      empty={xAxisData.length === 0}
      height={308}
      optionsProps={{ type: type }}
      options={options}
    ></EChartCommon>
  );
}
